module.exports = __webpack_public_path__ + "95866cc5e2f6784b36310fa1fc6f1612.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/covers/cover_24.jpg
 ** module id = 607
 ** module chunks = 0
 **/